import React, { useContext, useEffect} from "react";
import StackCustom from "../../general_components/StackCustom";
import { Button, Container, Typography} from "@mui/material";
import { PRIMARY_COLOR_DarkNavyBlue } from "../../constants/Colors";
import AddIcon from "@mui/icons-material/Add";
import ProjectCategory from "./components/ProjectCategory";
import CategoryModal from "./components/CategoryModal";
import { ProjectContext } from "../../contexts/ProjectContext";
import ProjectModal from "./components/ProjectModal";
import Page from "../../general_components/Page";
import { TeamContext } from "../../contexts/TeamsContext";

export default function Projects() {
  const projectContext = useContext(ProjectContext);
  const { fetchTeams} = useContext(TeamContext);
  const {
    categoryList, setCategoryList, setCategoryName, setLoading, handleAdd, categoryName, loading,
    handleOpen, handleClose, openModal, setOpenModal, show,setShow, handleOpenShow, handleCloseShow,
    projectGallaryImages, setProjectGallaryImages, projectGallaryRawImages, setprojectGallaryRawImages,
    isNewsFile, setIsNewsFile, companyName, setCompanyName, projectLoaction, setProjectLoaction,
    projectTypology, setProjectTypology, projectDescription, setProjectDescription, projectArea,
    setProjectArea, projectStatus, setProjectStatus, projectDate, setProjectDate, subCategoryList,
    handleAddCategory, fetchCategory, fullRawImage, setFullRawImage, cardImage, setCardImage,
    cardRawImage, setCardRawImage, projectSubCategory, setProjectSubCategory, fullImage,
    setFullImage, fetchProjects, handleAddProject, projectCategory,selectedTeam, setSelectedTeam
  } = projectContext;
  
  useEffect(() => {
    fetchCategory();
    fetchProjects();
    fetchTeams();
  }, []);

  return (
    <>
      <Page title="ARCSMEN Design Lab | Project">
        <Container>
          <StackCustom
            text={"Project"}
            children={
              <Button
                variant="contained"
                sx={{
                  backgroundColor: PRIMARY_COLOR_DarkNavyBlue,
                  color: "#fff",
                  marginLeft: 1.5,
                }}
                onClick={() => handleOpenShow()}
                startIcon={<AddIcon size={18} />}
              >
                Add Category
              </Button>
            }
          />
          <div
            style={{
              paddingRight: "2vw",
              display: "flex",
              gap: "20px",
              flexWrap: "wrap",
              marginTop: "50px",
              marginBottom: "20px",
            }}
          >
            {Array.isArray(categoryList) && categoryList.length > 0 ? (
              categoryList.map((category, index) => (
                <ProjectCategory
                  key={category.categoryId}
                  category={category}
                  index={index}
                />
              ))
            ) : (
              <Typography variant={"h6"}>No Categories Found</Typography>
            )}
          </div>
        </Container>
      </Page>
      <ProjectModal
        title="Add Project"
        text="Add Project"
        open={openModal}
        handleClose={handleClose}
        handleOpen={handleOpen}
        setOpen={setOpenModal}
        handlerFunction={handleAddProject}
        projectGallaryImages={projectGallaryImages}
        setProjectGallaryImages={setProjectGallaryImages}
        projectGallaryRawImages={projectGallaryRawImages}
        setprojectGallaryRawImages={setprojectGallaryRawImages}
        isNewsFile={isNewsFile}
        setIsNewsFile={setIsNewsFile}
        companyName={companyName}
        setCompanyName={setCompanyName}
        projectLoaction={projectLoaction}
        setProjectLoaction={setProjectLoaction}
        projectTypology={projectTypology}
        setProjectTypology={setProjectTypology}
        projectDescription={projectDescription}
        setProjectDescription={setProjectDescription}
        projectArea={projectArea}
        setProjectArea={setProjectArea}
        projectStatus={projectStatus}
        setProjectStatus={setProjectStatus}
        projectDate={projectDate}
        setProjectDate={setProjectDate}
        subCategoryList={subCategoryList}
        fullRawImage={fullRawImage}
        setFullRawImage={setFullRawImage}
        cardImage={cardImage}
        setCardImage={setCardImage}
        cardRawImage={cardRawImage}
        setCardRawImage={setCardRawImage}
        fullImage={fullImage}
        setFullImage={setFullImage}
        setProjectSubCategory={setProjectSubCategory}
        projectSubCategory={projectSubCategory}
        projectCategory={projectCategory}
        setSelectedTeam={setSelectedTeam}
        selectedTeam={selectedTeam}
      />

      <CategoryModal
        open={show}
        setOpen={setShow}
        categoryName={categoryName}
        setCategoryName={setCategoryName}
        loading={loading}
        setLoading={setLoading}
        handleClose={handleCloseShow}
        handleAdd={handleAdd}
        categoryList={categoryList}
        setCategoryList={setCategoryList}
        handleAddCategory={handleAddCategory}
      />
    </>
  );
}
